export const FILE_DOWNLOAD_REQUEST = 'FILE_DOWNLOAD_REQUEST'

export const downloadFile = (targetUrl) => {
    return {type: FILE_DOWNLOAD_REQUEST, payload: {url: targetUrl} }
}


// WEBPACK FOOTER //
// ./src/actions/file.js